import { Component, Inject, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { constant } from 'src/app/constant/constant';
import { StoreService } from 'src/app/services/Store/store.service';
import { UserService } from 'src/app/services/User/user.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  //=============VARIABLES===============
  hideOldPwd: boolean = true;
  hideNewPwd: boolean = true;
  hideConfirmPwd: boolean = true;
  userData: any = {};
  panelOpenState: boolean = false;
  isPasswordStrong: boolean = false;
  showDetails: boolean = true;
  showError: boolean = false;
  changePasswordAtLogin: boolean = false;
  password: string = '';

  // Strength properties
  strength: number = 0;
  strengthClass: string = '';
  strengthColor: ThemePalette = 'warn';
  strengthIcon: string = 'error';
  strengthMessage: string = 'Weak password';

  // Validation flags
  hasMinLength: boolean = false;
  hasUpperCase: boolean = false;
  hasLowerCase: boolean = false;
  hasNumber: boolean = false;
  hasSpecialChar: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public receivedData: any, private userService: UserService,
    private dialogRefPassword: MatDialogRef<ChangePasswordComponent>, private utilityService: UtilityService,
    private router: Router, private storeService: StoreService) {

    if (receivedData != undefined && receivedData.userData.changePasswordAtLogin != undefined) {
      this.changePasswordAtLogin = receivedData.userData.changePasswordAtLogin;
      this.userData.userName = receivedData.userData.user.userName;
      this.userData.NPINo = receivedData.userData.user.NPINo;

    } else {
      this.userData = {};
      this.userData.userName = sessionStorage.getItem('userName');
      this.userData.NPINo = sessionStorage.getItem('NPINo');
    }
  }

  ngOnInit(): void {
  }

  changeUserPassword() {
    this.userData.password = this.userData.oldPassword;

    this.userService.changeUserPassword(this.userData).subscribe(response => {

      var receivedUserResponse = JSON.parse(response.data);

      if (response.result == "SUCCESS") {
        var alertRef = this.utilityService.showAlert(
          "SUCCESS",
          "Success",
          "You have changed the password.\n Please login again with new password and update your QR code for continued access."
        ).subscribe(result => {
          this.userService.logOutUser();
          this.dialogRefPassword.close();
          alertRef.unsubscribe();
        });
      }
      else if (response.result == "ERROR") {

        this.utilityService.showAlert(
          constant.KEY_WARNING,
          "Warning",
          receivedUserResponse.result
        );


      } else {
        this.utilityService.showAlert(
          "ERROR",
          "Failed",
          "Error occurred while changing the password"
        );
      }
    });
  }

  changeUserPasswordAtLogin() {
    this.userData.password = this.userData.oldPassword;

    this.userService.changePasswordAtLogin(this.userData).subscribe(response => {
      var receivedUserResponse = JSON.parse(response.data);

      if (response.result == "SUCCESS") {
        var alertRef = this.utilityService.showAlert(
          constant.KEY_SUCCESS,
          constant.ALERT_SUCCESS_TITLE,
          "Password changed successfully.\n\nYou have changed the password\nPlease login again with the new password."
        ).subscribe(() => {
          this.userService.logOutUser();
          this.dialogRefPassword.close();
          alertRef.unsubscribe();
        });
      }
      else if (response.result == "ERROR") {

        this.utilityService.showAlert(
          constant.KEY_WARNING,
          "Warning",
          receivedUserResponse.result
        );
      } else {
        this.utilityService.showAlert(
          "ERROR",
          "Failed",
          "Error occurred while changing the password"
        );
      }
    });
    //#region Commented
    // this.storeService.getStoreDataFromStoreConfig(this.userData).subscribe(response => {

    //   var receivedUserResponse = JSON.parse(response.data);
    //   var storeData = receivedUserResponse.storeData;
    //   if (receivedUserResponse.userData != 'User not found') {


    //     let changePasswordInStoreConfig = this.storeService.changePasswordInStoreConfig(this.userData);
    //     let changePasswordInMPOS = this.userService.changePasswordAtLogin(this.userData);
    //     let changePasswordInEDI = this.userService.changePasswordInEDI(this.userData);


    //     forkJoin([changePasswordInStoreConfig]).subscribe(responses => {
    //       console.log('store config response');
    //       console.log(responses);
    //       if (responses[0].result == 'SUCCESS') {
    //         var storeConfig = "Password updated in store configurator successfully";
    //         if (storeData.isMpos) {
    //           forkJoin([changePasswordInMPOS]).subscribe(responses => {
    //             if (responses[0].result == constant.KEY_SUCCESS) {
    //               var mposMsg = "Password updated in ePrimePOS successfully";

    //               if (storeData.isEdiv2) {
    //                 forkJoin([changePasswordInEDI]).subscribe(responses => {
    //                   if (responses[0].result == 'SUCCESS') {

    //                     var ediMsg = "Password updated in EDIV2 successfully";

    //                     var alertRef = this.utilityService.showAlert(
    //                       constant.KEY_SUCCESS,
    //                       "Success",
    //                       (storeConfig + mposMsg + ediMsg)
    //                     ).subscribe(result => {

    //                       this.router.navigateByUrl('/login');
    //                       this.dialogRefPassword.close();

    //                       alertRef.unsubscribe();
    //                     });

    //                   } else {
    //                     var alertRef = this.utilityService.showAlert(
    //                       constant.KEY_SUCCESS,
    //                       "Success",
    //                       (storeConfig + mposMsg + 'Error while updating the password in EDI')
    //                     ).subscribe(result => {

    //                       this.router.navigateByUrl('/login');
    //                       this.dialogRefPassword.close();

    //                     });
    //                     alertRef.unsubscribe();
    //                     this.router.navigateByUrl('/login');
    //                     this.dialogRefPassword.close();

    //                   }
    //                 });
    //               } else {
    //                 var alertRef = this.utilityService.showAlert(
    //                   constant.KEY_SUCCESS,
    //                   "Success",
    //                   (storeConfig + mposMsg)
    //                 ).subscribe(result => {

    //                   this.router.navigateByUrl('/login');
    //                   this.dialogRefPassword.close();

    //                   alertRef.unsubscribe();
    //                 });
    //                 // this.router.navigateByUrl('/login');
    //                 // this.dialogRefPassword.close();

    //               }
    //             } else {
    //               var alertRef = this.utilityService.showAlert(
    //                 "SUCCESS",
    //                 "Success",
    //                 (storeConfig + 'Error while updating the password in ePrimePOS')
    //               ).subscribe(result => {

    //                 this.router.navigateByUrl('/login');

    //                 alertRef.unsubscribe();
    //               });


    //               // this.router.navigateByUrl('/login');

    //             }
    //           });
    //         } else {
    //           var alertRef = this.utilityService.showAlert(
    //             "SUCCESS",
    //             "Success",
    //             (storeConfig)
    //           ).subscribe(result => {

    //             this.router.navigateByUrl('/login');

    //             alertRef.unsubscribe();
    //           });
    //           // this.router.navigateByUrl('/login');

    //         }
    //       } else {
    //         var alertRef = this.utilityService.showAlert(
    //           "ERROR",
    //           "Failed",
    //           ('Old password does not match with current password. Please check your password')
    //         ).subscribe(result => {

    //           this.router.navigateByUrl('/login');

    //           alertRef.unsubscribe();
    //         });
    //         // this.router.navigateByUrl('/login');

    //       }
    //     });
    //   } else {
    //     this.userService.changePasswordAtLogin(this.userData).subscribe(response => {

    //       var receivedUserResponse = JSON.parse(response.data);

    //       if (response.result == "SUCCESS") {

    //         var alertRef = this.utilityService.showAlert(
    //           "SUCCESS",
    //           "Success",
    //           "Password changed successfully"
    //         ).subscribe(result => {

    //           var alertPassRef = this.utilityService.showAlert(
    //             "WARNING",
    //             "Warning",
    //             "You have changed the password please login again with new password"
    //           ).subscribe(result => {

    //             this.userService.logOutUser();
    //             this.dialogRefPassword.close();
    //             alertPassRef.unsubscribe();
    //           });
    //           alertRef.unsubscribe();
    //         });
    //       } else if (response.result == "ERROR") {

    //         this.utilityService.showAlert(
    //           "WARNING",
    //           "Warning",
    //           receivedUserResponse.result
    //         );
    //       } else {
    //         this.utilityService.showAlert(
    //           "ERROR",
    //           "Failed",
    //           "Error occurred while changing the password"
    //         );
    //       }
    //     });
    //   }
    // });
    //#endregion
  }

  onPasswordChange(password: string) {
    this.password = password;
    this.checkPasswordStrength();
    // Emit the strength changed event if needed
    this.onPasswordStrengthChanged(this.strength);
  }

  checkPasswordStrength() {
    // Reset all validations
    this.hasMinLength = this.password.length >= 8;
    this.hasUpperCase = /[A-Z]/.test(this.password);
    this.hasLowerCase = /[a-z]/.test(this.password);
    this.hasNumber = /[0-9]/.test(this.password);
    this.hasSpecialChar = /[^A-Za-z0-9]/.test(this.password);

    // Calculate strength (0-100)
    const requirements = [
      this.hasMinLength,
      this.hasUpperCase,
      this.hasLowerCase,
      this.hasNumber,
      this.hasSpecialChar
    ];

    const metCount = requirements.filter(Boolean).length;
    this.strength = (metCount / requirements.length) * 100;

    // Update UI properties
    this.updateStrengthUI();
  }

  updateStrengthUI() {
    if (this.strength < 40) {
      this.strengthClass = 'weak';
      this.strengthColor = 'warn';
      this.strengthIcon = 'error';
      this.strengthMessage = 'Weak password';
    } else if (this.strength < 80) {
      this.strengthClass = 'medium';
      this.strengthColor = 'accent';
      this.strengthIcon = 'warning';
      this.strengthMessage = 'Medium password';
    } else {
      this.strengthClass = 'strong';
      this.strengthColor = 'primary';
      this.strengthIcon = 'check_circle';
      this.strengthMessage = 'Strong password';
    }
  }

  onPasswordStrengthChanged(event: any) {
    if (event == 100) {
      this.isPasswordStrong = true;
    } else {
      this.isPasswordStrong = false;
    }
  }
}
